import { observer } from "owa-mobx-react";
import React from "react";
import { IconComponent } from "../utils/getIconComponentFromName";
import { tokens } from "@fluentui/react-components";
import { getDensityModeString } from "owa-fabric-theme";
import { type TouchState, type TouchThreshold } from "touch-behavior";
import { getPaletteAsRawColors } from "owa-theme";
import { getBackgroundColorForSwipeAction, getSwipeRightAction, getSwipeLeftAction, getIconColorForSwipeAction, getIconForSwipeAction, } from "owa-mail-list-swipe-utils";

import { swipeContainer, swipeRight, swipeLeft, swipeIcon, swipeIconFull, } from "./SwipeInProgressPlaceholder.scss";
import classnames from "owa-classnames";

export interface SwipeInProgressPlaceholderProps {
    isSwipeRight: boolean;
    state: TouchState;
    threshold: TouchThreshold;
    isUnread: boolean;
}

export const SwipeInProgressPlaceholder: React.FunctionComponent<SwipeInProgressPlaceholderProps> = observer(function SwipeInProgressPlaceholder(props: SwipeInProgressPlaceholderProps) {
    const { isSwipeRight, state, threshold, isUnread } = props;
    const swipeAction = isSwipeRight ? getSwipeRightAction() : getSwipeLeftAction();
    const iconForSwipeAction = getIconForSwipeAction(swipeAction, isUnread);
    const swipeIconColor = getIconColorForSwipeAction(swipeAction);
    const densityModeString = getDensityModeString();
    
    const isBackgroundColorEnabled = React.useMemo(() => {
        return isSwipeRight
            ? state.moveX > threshold.action || state.leftAction
            : state.moveX < -threshold.action || state.rightAction;
    }, [isSwipeRight, state]);
    
    const swipeContainerBgStyles = React.useMemo(() => ({
        backgroundColor: isBackgroundColorEnabled
            ? getBackgroundColorForSwipeAction(swipeAction)
            : getPaletteAsRawColors().paneLighterBackground,
    }), [swipeAction, isBackgroundColorEnabled, getPaletteAsRawColors().paneLighterBackground]);
    
    const swipeIconAdditionalStyles: React.CSSProperties = React.useMemo(() => {
        const marginToSet = isSwipeRight ? "marginLeft" : "marginRight";
        
        return {
            color: isBackgroundColorEnabled ? swipeIconColor : tokens.colorNeutralForeground1,
            [marginToSet]: "15px",
        };
    }, [isSwipeRight, isBackgroundColorEnabled, swipeIconColor]);
    return (<div className={classnames(swipeContainer, isSwipeRight ? swipeRight : swipeLeft)} style={swipeContainerBgStyles}>
                <IconComponent iconName={iconForSwipeAction} className={classnames(swipeIcon, densityModeString === "full" && swipeIconFull)} style={swipeIconAdditionalStyles}/>
            </div>);
}, "SwipeInProgressPlaceholder");
